(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-playlist/assets/javascripts/helpers/utils.js') >= 0) return;  svs.modules.push('/components/components/youtube-playlist/assets/javascripts/helpers/utils.js');
'use strict';

var _trinidad$components$, _svs;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
const trinidad = isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const {
  getJsonLDString
} = isServer ? trinidad.components.require('utils', 'get-json-ld') : svs.utils;
const logger = isServer ? trinidad.logger('components:youtube-playlist:utils') : new svs.core.log.Logger('components:youtube-playlist:utils');
const routesDomain = isServer ? trinidad.options.routesDomain : svs.core.config.data.svsconfig.routesDomain;
const getCmsClient = isServer ? (_trinidad$components$ = trinidad.components.require('content', 'shared').apiUtils) === null || _trinidad$components$ === void 0 ? void 0 : _trinidad$components$.getCmsClient : (_svs = svs) === null || _svs === void 0 || (_svs = _svs.content) === null || _svs === void 0 || (_svs = _svs.shared) === null || _svs === void 0 ? void 0 : _svs.getCmsClient;
const YOUTUBE_DOMAIN = 'https://www.youtube-nocookie.com';
const WEBP_IMG_DOMAIN = 'https://i.ytimg.com/vi_webp';
const YT_IMG_DOMAIN = 'https://i.ytimg.com/vi';
function nameSafeString() {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const safeString = string.replace(/^[.\s]+/g, '').replace(/[?!"()&€%]/g, '').replace(/[@]/g, '_a_').replace(/[åäáà]/gi, 'a').replace(/[é]/gi, 'e').replace(/[ö]/gi, 'o').replace(/[^a-z0-9._-]/gi, '-').toLowerCase();
  return safeString;
}
const urlRegex = /(https?:\/\/[^\s]+)/g;
function splitTextWithUrl(text) {
  return text.split(urlRegex);
}
function truncateUrl(url) {
  let maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  const baseUrl = url.split('?')[0];
  if (baseUrl.length <= maxLength) {
    return baseUrl;
  }
  if (maxLength < 5) {
    return baseUrl.slice(0, maxLength);
  }
  return "".concat(baseUrl.slice(0, maxLength - 3), "...");
}
function isUrl(text) {
  return text.match(urlRegex);
}
function parseLinks(text) {
  let maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!text) {
    return;
  }
  const urlPattern = /(https?:\/\/\S+)/gi;

  const replacedText = text.replace(urlPattern, url => {
    let visibleText;
    try {
      const parsedUrl = new URL(url);
      visibleText = "".concat(parsedUrl.protocol, "//").concat(parsedUrl.hostname).concat(parsedUrl.pathname);
    } catch (e) {
      visibleText = url;
    }

    if (maxLength && visibleText.length > maxLength) {
      visibleText = "".concat(visibleText.substring(0, maxLength), "...");
    }
    return "<a href=\"".concat(url, "\">").concat(visibleText, "</a>");
  });
  return replacedText.replace(/\n\n/g, '<br>');
}
function secondsToMinutes(duration) {
  const minutes = Math.floor(duration / 60);
  const remainingSeconds = duration % 60;
  return "".concat(minutes, ":").concat(remainingSeconds < 10 ? '0' : '').concat(remainingSeconds);
}
function formatDate(dateString) {
  try {
    const date = new Date(dateString);
    if (isNaN(date)) {
      logger.warn('Invalid date string');
      return null;
    }
    const options = {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    };
    const formattedDate = date.toLocaleDateString('sv-SE', options);
    return formattedDate.replace('.', '');
  } catch (error) {
    logger.warn('Error formatting date:', error);
    return null;
  }
}
function trackClick(_event, videoId, videoTitle) {
  const videoLabel = videoTitle ? "".concat(videoId, "-").concat(videoTitle) : "".concat(videoId);
  svs.components.analytics.trackEvent({
    action: 'Play',
    category: 'Video',
    opt_label: videoLabel,
    opt_value: 1
  });
}
async function getVideoInfo(videoId, parentId, req) {
  const useLegacyJupiterApi = isServer ? !(await req.feature('ft-use-cms-api-client')) : !svs.core.detect.feature('ft-use-cms-api-client');
  try {
    let response;
    if (useLegacyJupiterApi) {
      response = await trinidad.jupiter.callAsync({
        method: 'GET',
        path: "/content/2/id/".concat(parentId, "?routesDomain=").concat(routesDomain),
        req
      });
    } else {
      const client = getCmsClient(req);
      response = await client.v1.content.getByIds({
        ids: String(parentId)
      });
    }
    const data = await response;
    if (!data || !data.result || !Array.isArray(data.result) || data.result.length === 0) {
      logger.warn('Invalid data format received from API');
    }
    const contentItem = data.result[0];
    const videoPlaylists = contentItem.videoPlaylists;
    if (!videoPlaylists || !Array.isArray(videoPlaylists) || videoPlaylists.length === 0) {
      logger.warn('No video playlists found in the data');
    }
    for (const playlist of videoPlaylists) {
      const video = playlist.videos.find(v => v.id === videoId);
      if (video) {
        const {
          publishedAt,
          duration,
          title,
          description
        } = video;
        return {
          publishedAt,
          duration,
          title,
          description
        };
      }
    }
    logger.warn("Video with ID ".concat(videoId, " not found"));
  } catch (error) {
    logger.warn('Failed to fetch video information:', error);
  }
}
async function decorateVideo(video, options, callback) {
  try {
    if (!video) {
      return callback('Video object is required');
    }
    let videoInfo;
    const {
      videoPlayerUrl,
      parentId,
      req
    } = options || {};
    if (parentId) {
      videoInfo = await getVideoInfo(video.id, parentId, req);
    }
    const {
      id,
      name,
      type,
      buttonText
    } = video;
    const duration = videoInfo ? videoInfo.duration : video.duration;
    const publishedAt = videoInfo ? videoInfo.publishedAt : video.publishedAt;
    const title = videoInfo ? videoInfo.title : video.title;
    const description = videoInfo ? videoInfo.description : video.description;
    const formattedDate = publishedAt ? formatDate(publishedAt) : undefined;
    const formattedDuration = duration ? secondsToMinutes(duration) : undefined;
    const nameSafeTitle = nameSafeString(title);
    const model = {
      name: name || '100',
      type: type || 'youtube',
      src: "".concat(YOUTUBE_DOMAIN, "/embed/").concat(id, "?rel=0"),
      videoId: id,
      thumbnailUrl: "".concat(YT_IMG_DOMAIN, "/").concat(id),
      title: title || 'Svenska Spel Video',
      duration: formattedDuration,
      description,
      publishedAt,
      formattedDate,
      buttonText,
      webpThumbnailUrl: "".concat(WEBP_IMG_DOMAIN, "/").concat(id)
    };
    if (videoPlayerUrl) {
      model.videoPlayerUrl = "".concat(videoPlayerUrl, "/").concat(parentId, "/").concat(id, "/").concat(nameSafeTitle);
    }
    const jsonLDTags = getJsonLDString({
      uploadDate: model.publishedAt,
      description: model.description,
      name: model.title,
      thumbnailUrl: model.thumbnailUrl,
      duration
    });
    callback(null, _objectSpread(_objectSpread({}, model), {}, {
      jsonLDTags
    }));
  } catch (error) {
    logger.warn('Failed to decorate video:', error);
    callback(error);
  }
}
async function decoratePlaylist(videoPlaylists, options, callback) {
  const {
    count,
    videoPlayerUrl,
    parentId,
    req
  } = options || {};
  if (!videoPlaylists || videoPlaylists.length === 0) {
    return callback('No video playlists found', null);
  }
  const videos = videoPlaylists[0].videos;
  if (!videos || videos.length === 0) {
    return callback('No videos found', null);
  }
  const [latestVideo, ...remainingVideos] = videos;
  const limitedRemainingVideos = remainingVideos.slice(0, count);
  try {
    const decoratedLatestVideo = await new Promise((resolve, reject) => {
      decorateVideo(latestVideo, {
        videoPlayerUrl,
        parentId,
        req
      }, (err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    });

    const decoratedRemainingVideosPromises = limitedRemainingVideos.map(video => new Promise((resolve, reject) => {
      decorateVideo(video, {
        videoPlayerUrl,
        parentId,
        req
      }, (err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    }));
    const decoratedRemainingVideos = await Promise.all(decoratedRemainingVideosPromises);
    callback(null, {
      latestVideo: decoratedLatestVideo,
      remainingVideos: decoratedRemainingVideos
    });
  } catch (error) {
    callback(error, null);
  }
}
if (isServer) {
  module.exports = {
    nameSafeString,
    parseLinks,
    splitTextWithUrl,
    truncateUrl,
    isUrl,
    secondsToMinutes,
    formatDate,
    decorateVideo,
    decoratePlaylist
  };
} else {
  svs.components.youtube_playlist.utils = {
    nameSafeString,
    parseLinks,
    splitTextWithUrl,
    truncateUrl,
    isUrl,
    secondsToMinutes,
    formatDate,
    decorateVideo,
    decoratePlaylist,
    trackClick,
    getVideoInfo
  };
}

 })(window);